import Box from "@mui/material/Box";
import React from "react";

import { useDatapointsSelectionFiltered, useUnfilteredDatapoints } from "containers/hooks/useData";
import { VisualizationPageHeader } from "../Components/VisualizationPageHeader";
import NoDataComponent from "../Components/NoDataComponent";
import { useAppSelector } from "../../index";
import Typography from "@mui/material/Typography";
import useTranslations from "../hooks/useLanguageHook";
import NoVisualComponent from "../Components/NoVisualComponent";
import { VisTypes } from "@store/options/types";
import useTheme from "@mui/material/styles/useTheme";

type ComponentProps = {
  title: string;
  children: React.ReactNode;
  help: {
    title: string;
    description: string;
    image: string;
  };
};
function VisPageWrapper(props: ComponentProps) {
  const currentVis = useAppSelector((state) => state.options.currentVis);

  const { t } = useTranslations();
  const theme = useTheme();
  const data = useDatapointsSelectionFiltered();
  const fullData = useUnfilteredDatapoints();

  const elementRef = React.useRef<undefined | HTMLDivElement>(undefined);

  return (
    <Box
      sx={{
        alignItems: "center",
        pb: `calc(${theme.sidebar.footerHeight}px + 3rem)`,
      }}
      ref={elementRef}
    >
      <VisualizationPageHeader title={props.title} help={props.help} reference={elementRef} />

      {fullData.length === 0 ? (
        <NoDataComponent />
      ) : (
        <>
          {/* <TimelineSelector
            settings={{
              bins: 50,
            }}
            onSelected={(e) => {
              if (e) dispatch(setTimelineSelection(e));
            }}
            size={{ width: "100%" }}
          /> */}
          {data.length === 0 && currentVis !== VisTypes.Timeline ? (
            <NoVisualComponent />
          ) : (
            <>
              {props.children}
              <Typography
                sx={{
                  fontSize: "0.7em",
                  color: "grey",
                  height: theme.sidebar.footerHeight,
                }}
              >
                {t.Vis.Notice}
              </Typography>
            </>
          )}
        </>
      )}
    </Box>
  );
}

export { VisPageWrapper };
